<template>
  <form ref="form" action="#" method="post">
    <input type="hidden" name="_token" :value="csrfToken" />
    <input type="hidden" name="message_index" :value="stepNo + 1" />
    <div class="l-page l-page--message-edit">
      <main class="l-main">
        <!-- パンくずリスト -->
        <breadcrumb :breadcrumb-data="breadcrumbData" />
        <!-- /パンくずリスト -->

        <div class="l-main-head">
          <div class="c-title u-w420">
            <h2 class="c-title__text c-title__text--blue u-fs34">シナリオの新規作成</h2>
          </div>
          <div class="c-progress c-progress--step-message">
            <ul class="c-progress-list">
              <li class="c-progress-list__item">シナリオ名の作成<br />配信条件設定</li>
              <li class="c-progress-list__item" :class="stepNo <= 1 ? 'is-current' : ''">メッセージの作成</li>
              <li class="c-progress-list__item" :class="stepNo > 1 ? 'is-current' : ''">トリガー設定と<br />追加配信メッセージの作成</li>
              <li class="c-progress-list__item">配信内容の<br />確認</li>
              <li class="c-progress-list__item">設定完了</li>
            </ul>
          </div>
        </div>

        <div class="l-main-content">
          <div class="p-message-edit-confirm">
            <div class="p-message-edit-confirm-list">
              <div class="p-message-edit-confirm-list__item">
                <div class="p-message-edit-confirm__title">シナリオ名</div>
                <div class="p-message-edit-confirm__text">{{ scenario.scenario_name }}</div>
              </div>
              <div class="p-message-edit-confirm-list__item">
                <div class="p-message-edit-confirm__title">プッシュ対象</div>
                <div class="c-tag">
                  <ul class="c-tag-list">
                    <li class="c-tag-list__item c-tag-list__item--green">ブラウザ</li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- トリガーを設定 -->
        <div v-if="stepNo > 1" class="l-main-content">
          <div class="p-message-edit p-message-edit--delivery-segment-group">
            <div class="c-title">
              <div class="c-title__text u-fs24">{{ stepNo }}通目を配信するトリガーとタイミング（アクションと日時）を設定する</div>
            </div>
            <!-- 確認画面で 1通目 だけ未来日時に変更されたケースで 2通目以降の元日時が過去側に
                         なっており「何日後」を再設定する必要があることをユーザに伝える警告。
                         プロジェクト内に警告専用クラスが存在しないため既存のエラー表示 c-error.is-active を流用する。 -->
            <div v-if="isSpanDayOutOfRange" class="c-error is-active">
              <p class="c-error__text">1通目の配信日時を変更したため、{{ stepNo }}通目の配信タイミング（何日後・時・分）を再設定してください。</p>
            </div>
            <div class="p-message-edit-list p-message-edit-list--first">
              <div class="p-message-edit-list__item">
                <div class="c-select-card">
                  <ul class="c-select-card-list">
                  </ul>
                  <div class="c-error c-error--balloon">
                    <div class="c-error__text"></div>
                  </div>
                </div>
              </div>
              <div class="p-message-edit-list__item">
                <select-text
                  ref="spanDaySelect"
                  :classes="['u-w240']"
                  place-holder="何日後かを選択"
                  :elements="spanDays"
                  input-name="span_day_select"
                  :is-error="isValidated && spanDay == null ? true : false"
                  error-message="-"
                  @select="onSpanDaySelect"
                />

                <div class="c-select u-w60">
                  日後の
                </div>

                <select-text
                  ref="spanHourSelect"
                  :classes="['u-w150']"
                  place-holder="時"
                  :elements="spanHours"
                  input-name="span_hour_select"
                  :is-error="isValidated && spanHour == null ? true : false"
                  error-message="-"
                  @select="onSpanHourSelect"
                />

                <div class="c-select u-w60">
                  時
                </div>

                <select-text
                  ref="spanMinuteSelect"
                  :classes="['u-w150']"
                  place-holder="分"
                  :elements="spanMinutes"
                  input-name="span_minute_select"
                  :is-error="isValidated && spanMinute == null ? true : false"
                  error-message="-"
                  @select="onSpanMinuteSelect"
                />
                <div class="c-select u-w260">
                  分 に
                </div>
              </div>
              <div class="p-message-edit-list__item">
                <select-text
                  ref="deliverTargetSelect"
                  :classes="['u-w450']"
                  place-holder="トリガーとなるアクションを選択してください"
                  :elements="stepInfo.deliverTargetTypes"
                  input-name="deliver_target_select"
                  :is-error="isValidated && deliverTarget == null ? true : false"
                  error-message="-"
                  @select="onDeliverTargetSelect"
                />
                <div class="c-select u-w450">
                  ユーザーに {{ stepNo }}通目のメッセージを配信する
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- トリガーを設定 -->


        <div class="l-main-content l-main-content--half l-main-content--left">
          <!-- 配信メッセージ設定 -->
          <message-form
            ref="messageForm"
            v-model="message"
            :custom-utm-parameters="customUtmParameters"
            @optimize-start="onStartOptimize"
            @optimize-end="onEndOptimize"
          />
          <message-action-form
            v-if="stepNo == 1"
            ref="messageActionForm"
            v-model="messageAction"
            :skip-regular="true"
          />
        </div>
        <div class="l-main-content l-main-content--half l-main-content--right">
          <div class="p-message-preview">
            <div class="c-title c-title--left u-text-white-1">
              <div class="c-title__text u-fs--l ">プレビュー</div>
              <div class="c-text u-fs10">実際の配信メッセージと表示が異なることがあります</div>
            </div>
            <!--
                    <ul class="c-tab-list">
                        <li class="c-tab-list__item is-active" data-type="desktop">PCでの配信例</li>
                        <li class="c-tab-list__item" data-type="mobile">スマホでの配信例</li>
                    </ul>
                    -->
            <div class="p-message-preview-list">
              <message-preview
                :title="message.messageTitle"
                :text="message.messageText"
                :url="message.clickUrl"
                :icon-url="currentIconUrl"
                :large-image-url="message.largeImageUrl"
                :has-button-a="message.hasButtonA"
                :has-button-b="message.hasButtonB"
                :action-button-text-a="message.actionButtonTextA"
                :action-button-text-b="message.actionButtonTextB"
              />
            </div>
          </div>
        </div>
      </main>
    </div>
    <div class="p-message-predict p-message-predict--no-number">
      <div class="p-message-predict__content">
        <div class="p-message-predict-suspend">
          <div class="p-message-predict-suspend__items">
            <button
              class="c-btn c-btn--block u-w146 u-fs24"
              type="button"
              name="destroy"
              value="destroy"
              @click="onCancelClick($event)"
            >
              <p class="c-btn__text">作成をやめる</p>
            </button>
          </div>
          <div class="p-message-predict-suspend__items">
            <button
              class="c-btn c-btn--block u-w96 u-fs24"
              :class="{ 'is-loading': isLoadingOptimizeImage }"
              :disabled="isLoadingOptimizeImage"
              type="button"
              name="save"
              value="save"
              @click="onSaveClick($event)"
            >
              <p class="c-btn__text">保存する</p>
            </button>
          </div>
        </div>
        <div v-if="stepNo <= 1" class="p-message-predict__btns">
          <button
            class="c-btn c-btn--blue u-w520 u-h50 u-fs20"
            :class="{ 'is-loading': isLoadingOptimizeImage }"
            :disabled="isLoadingOptimizeImage"
            type="button"
            name="next"
            value="next"
            @click="onNextClick($event)"
          >
            <p class="c-btn__text">次の配信へのトリガー設定とメッセージ作成</p>
          </button>
        </div>

        <div v-if="stepNo > 1" class="p-message-predict__btns">
          <button
            class="c-btn c-btn--blue u-w320 u-h50 u-fs20"
            :class="{ 'is-loading': isLoadingOptimizeImage }"
            :disabled="isLoadingOptimizeImage"
            type="button"
            name="next"
            value="prev"
            @click="onNextClick($event)"
          >
            <p class="c-btn__text">{{ stepNo + 1 }}通目のメッセージを作成する</p>
          </button>
          <button
            class="c-btn c-btn--blue u-w320 u-h50 u-fs20"
            :class="{ 'is-loading': isLoadingOptimizeImage }"
            :disabled="isLoadingOptimizeImage"
            type="button"
            name="confirm"
            value="next"
            @click="onConfirmClick($event)"
          >
            <p class="c-btn__text">設定を完了して確認に進む</p>
          </button>
        </div>

      </div>
    </div>

    <!-- モーダル: エラーメッセージ表示 -->
    <error-modal
      :is-active=isError
      :message=errorMessage
      :on-close-click="onCloseErrorModal"
    />

  </form>
</template>

<script>
import axios from 'axios';
import moment from 'moment';

export default {
  props: {
    stepInfo: Object,
    csrfToken: String,
    breadcrumbData: Array,
    stepNo: Number,
    scenario: Object,
    previousMessage: Object,
    groupId: String,
    conditionIds: Array,
    topicConditionIds: Array,
    customUtmParameters: {
      type: Object,
      default: () => {}
    },
    defaultIconUrl: String,
  },
  data () {
    return {
      selectedGroupId: this.groupId,


      isValidated: false,
      isLoadingConfirmBtn: false,
      isLoadingNextBtn: false,
      isLoadingSaveBtn: false,
      isLoadingOptimizeImage: false,
      message: {
        messageTitle: null,
        messageText: null,
        clickUrl: null,
        iconUrl: null,
        selectedIconFile: null,
        largeImageUrl: null,
        selectedLargeImageFile: null,
        hasButtonA: false,
        hasButtonB: false,
        actionButtonTextA: null,
        actionButtonUrlA: null,
        actionButtonTextB: null,
        actionButtonUrlB: null,
        conditionJoinType: (new URL(document.location)).searchParams.get('condition_join_type') || 'AND',
        adFlag: null,
        customUtmParameter: null,
        customUtmParameterActionA: null,
        customUtmParameterActionB: null,
      },
      messageAction: {
        requireInteraction: '0',
        sendStartDate: null,
        sendStartTime: null,
        deliverType: '4',
        regularType: [],
        regularStartDate: null,
        regularEndDate: null,
        targetStartTime: null,
      },
      messageId: null,
      currentButton: null,
      serviceType: null,
      errorMessage: '',
      isError: false,
      nextUrl: null,
      deliverTarget: null,
      spanDay: null,
      spanHour: null,
      spanMinute: null,
      // 前ステップの送信日時。mounted で previousMessage から復元する。
      // data に明示しないと Vue 2 では非リアクティブになり、saveMessage 内の日時計算で
      // undefined を踏む。
      previousStartDate: null,
      // 確認画面で 1通目 だけ未来日時に変更され、2通目以降の元日時が 1通目より過去になっている
      // 場合に true。currentSpanDay が負数となるため UI 側で 0 にクランプしつつ、
      // ユーザに「2通目以降の配信タイミングを再設定してください」と警告する。
      isSpanDayOutOfRange: false,
      spanDays: {
        '0': '0',
        '1': '1',
        '2': '2',
        '3': '3',
        '4': '4',
        '5': '5',
        '6': '6',
        '7': '7',
      },
      spanHours: {
        '0': '0',
        '1': '1',
        '2': '2',
        '3': '3',
        '4': '4',
        '5': '5',
        '6': '6',
        '7': '7',
        '8': '8',
        '9': '9',
        '10': '10',
        '11': '11',
        '12': '12',
        '13': '13',
        '14': '14',
        '15': '15',
        '16': '16',
        '17': '17',
        '18': '18',
        '19': '19',
        '20': '20',
        '21': '21',
        '22': '22',
        '23': '23',
      },
      spanMinutes: {
        '0': '0',
        '1': '1',
        '2': '2',
        '3': '3',
        '4': '4',
        '5': '5',
        '6': '6',
        '7': '7',
        '8': '8',
        '9': '9',
        '10': '10',
        '11': '11',
        '12': '12',
        '13': '13',
        '14': '14',
        '15': '15',
        '16': '16',
        '17': '17',
        '18': '18',
        '19': '19',
        '20': '20',
        '21': '21',
        '22': '22',
        '23': '23',
        '24': '24',
        '25': '25',
        '26': '26',
        '27': '27',
        '28': '28',
        '29': '29',
        '30': '30',
        '31': '31',
        '32': '32',
        '33': '33',
        '34': '34',
        '35': '35',
        '36': '36',
        '37': '37',
        '38': '38',
        '39': '39',
        '40': '40',
        '41': '41',
        '42': '42',
        '43': '43',
        '44': '44',
        '45': '45',
        '46': '46',
        '47': '47',
        '48': '48',
        '49': '49',
        '50': '50',
        '51': '51',
        '52': '52',
        '53': '53',
        '54': '54',
        '55': '55',
        '56': '56',
        '57': '57',
        '58': '58',
        '59': '59',
      },

    }
  },
  computed: {
    currentMessage: function() {
      let currentMessage = null;
      let currentScenarioMessage = this.currentScenarioMessage;
      if(currentScenarioMessage){
        currentMessage = currentScenarioMessage.message;
      }
      return currentMessage;
    },
    currentScenarioMessage: function() {
      let currentScenarioMessage = null;
      if(this.scenario){
        if(this.scenario.scenario_messages && this.scenario.scenario_messages.length >= this.stepNo){
          currentScenarioMessage = this.scenario.scenario_messages[this.stepNo-1];
        }
      }
      return currentScenarioMessage;
    },
    currentDeliverTarget: function() {
      let currentDeliverTarget = null;
      let currentScenarioMessage = this.currentScenarioMessage;
      if(currentScenarioMessage){
        currentDeliverTarget = currentScenarioMessage.deliver_target;
      }
      return currentDeliverTarget;
    },

    currentDeliverDateTime: function() {
      let deliverDateTime = '';
      let currentMessage = this.currentMessage;
      if(currentMessage){
        deliverDateTime = currentMessage.message_deliver.send_start_date;
      }

      return deliverDateTime;
    },

    currentSpanDay: function() {
      let spanDay = 0;
      let stepNo = this.stepNo;
      if(stepNo > 1){
        let previousMessage = this.scenario.scenario_messages[stepNo-2];
        let currentMessage = this.scenario.scenario_messages[stepNo-1];
        let previousDate = previousMessage && previousMessage.message && previousMessage.message.message_deliver
          ? previousMessage.message.message_deliver.send_start_date
          : null;
        let currentDate = currentMessage && currentMessage.message && currentMessage.message.message_deliver
          ? currentMessage.message.message_deliver.send_start_date
          : null;
        if(!previousDate || !currentDate){
          return 0;
        }

        let dateFrom = moment(previousDate.substring(0,10));
        let dateTo = moment(currentDate.substring(0,10));
        let diffDays = dateTo.diff(dateFrom, 'days');
        // 確認画面で 1通目 を 2通目 より未来日時に変更したまま遷移すると diff が負数になる。
        // /api/scenario/setmessage は 1通目 だけ更新するため 2通目以降の send_start_date は
        // DB 上で再計算されないことに起因する。selectText.elements には 0-7 のキーしか無く
        // 負数キーは undefined となり「何日後」表示が空白にリセットされてしまう（バグ⑴）。
        // ここで 0 にクランプして UI を破綻させず、isSpanDayOutOfRange フラグで再設定を促す。
        if(diffDays < 0){
          spanDay = 0;
        } else {
          spanDay = diffDays;
        }
      }
      return spanDay;
    },
    currentSpanHour: function() {
      let spanHourString = '';
      let currentDateString = this.currentDeliverDateTime;
      if(currentDateString){
        spanHourString = moment(currentDateString).format('H');
      }

      return spanHourString;
    },
    currentSpanMinute: function() {
      let spanMinuteString = '';
      let currentDateString = this.currentDeliverDateTime;
      if(currentDateString){
        spanMinuteString = moment(currentDateString).format('m');
      }

      return spanMinuteString;
    },
    currentIconUrl: function() {
      return this.message.iconUrl || this.defaultIconUrl;
    }
  },
  mounted: function() {
    import('../../funcs/pages/message-add').then(module => {
      module.MessageAdd();
    });
    import('../../funcs/components/select').then(module => {
      module.Select();
    });

    if(this.previousMessage){
      if(this.previousMessage.message_deliver){
        this.previousStartDate = this.previousMessage.message_deliver.send_start_date;
      }
    }

    if(this.currentMessage){
      let message = this.currentMessage;

      this.messageId = message.message_id;
      this.message.messageTitle = message.message_title;
      this.message.messageText = message.message_text;
      this.message.clickUrl = message.click_url;
      this.messageAction.requireInteraction = message.require_interaction;
      if(message.action_button_text_a && message.action_button_url_a){
        this.message.hasButtonA = true;
        this.message.actionButtonTextA = message.action_button_text_a;
        this.message.actionButtonUrlA = message.action_button_url_a;
      } else {
        this.message.hasButtonA = false;
      }
      if(message.action_button_text_b && message.action_button_url_b){
        this.message.hasButtonB = true;
        this.message.actionButtonTextB = message.action_button_text_b;
        this.message.actionButtonUrlB = message.action_button_url_b;
      } else {
        this.message.hasButtonB = false;
      }
      this.messageAction.deliverType = message.message_deliver.deliver_type;
      if(this.messageAction.deliverType == 1){
        this.messageAction.sendStartDate = message.message_deliver.send_start_date;
        this.messageAction.sendStartTime = message.message_deliver.send_start_time;
      } else if(this.messageAction.deliverType == 3){
        // 定期配信
        // message_deliver.regular_type に曜日情報 0111110 1がON
        // target_start_time に 配信開始時間
        let regularType = message.message_deliver.regular_type;
        this.messageAction.regularType = [];
        for(let day = 0; day < 7; day++){
          let flag = regularType.substring(day,day+1);
          if(flag == '1'){
            this.messageAction.regularType.push('' + day);
          }
        }
        this.messageAction.regularStartDate = message.message_deliver.send_start_date;
        this.messageAction.regularEndDate = message.message_deliver.send_end_date;
      }

      if(message.message_group_message != null){
        this.groupType = 1;
        this.selectedGroupId = message.message_group_message.group_id;
        this.$refs.groupSelect.setValue(this.selectedGroupId);
      } else {
        this.groupType = 2;
      }

      if(message.image_url){
        this.message.iconUrl = message.image_url;
      }
      if(message.large_image_url){
        this.message.largeImageUrl = message.large_image_url;
      }

      if(this.stepNo > 1){
        // クランプ前の生の日数差で「1通目を未来側に動かしたために 2通目以降が過去になっている」
        // 異常状態を検出する。currentSpanDay 側でも 0 にクランプしているが、UI の警告表示には
        // クランプ前の判定が必要。
        if(this.previousStartDate && this.currentDeliverDateTime){
          let dateFrom = moment(this.previousStartDate.substring(0,10));
          let dateTo = moment(this.currentDeliverDateTime.substring(0,10));
          if(dateFrom.isValid() && dateTo.isValid() && dateTo.diff(dateFrom, 'days') < 0){
            this.isSpanDayOutOfRange = true;
          }
        }
        this.deliverTarget = this.currentDeliverTarget;
        this.$refs.deliverTargetSelect.setValue(this.currentDeliverTarget);
        this.spanDay = this.currentSpanDay;
        this.$refs.spanDaySelect.setValue(this.spanDay);
        this.spanHour = this.currentSpanHour;
        this.$refs.spanHourSelect.setValue(this.spanHour);
        this.spanMinute = this.currentSpanMinute;
        this.$refs.spanMinuteSelect.setValue(this.spanMinute);
      }
    }

  },
  methods: {
    showCalendar: function(name) {
      $("*[name="+name+"]").click();
    },
    onCancelClick: function(event) {
      event.preventDefault();
      location.href = this.stepInfo.cancelUrl;
    },

    // -----------------------------------------------------------------------------------------------------
    // イベント系メソッド一覧: UI操作にフックしてコールされるメソッド
    // -----------------------------------------------------------------------------------------------------
    // クリック: 配信条件設定画面へ
    onNextClick: function(event) {
      event.preventDefault();
      if(this.validate()){
        this.nextUrl = this.stepInfo.addMessageUrl +
          '?scenario_id=' + this.scenario.scenario_id +
          '&step_no=' + (this.stepNo + 1);
        this.isLoadingNextBtn = true;
        this.saveMessage();
      } else {
        this.isError = true;
        this.errorMessage = '入力を確認してください';
      }
    },

    // クリック: 確認画面へ
    onConfirmClick: function() {
      if(this.validate()){
        this.nextUrl = this.stepInfo.confirmUrl + '?scenario_id=' + this.scenario.scenario_id;
        this.isLoadingConfirmBtn = true;
        this.saveMessage();
      } else {
        this.isError = true;
        this.errorMessage = '入力を確認してください';
      }
    },

    // クリック: 作成キャンセル
    onQuitClick: function() {
      location.href = this.stepInfo.listUrl;
    },

    // クリック: 作成内容の途中保存
    onSaveClick: function() {
      if(this.validate()){
        this.isLoadingSaveBtn = true;
        this.nextUrl = this.stepInfo.listUrl;
        this.saveMessage();
      } else {
        this.isError = true;
        this.errorMessage = '入力を確認してください';
      }
    },
    onGroupSelect: function(selected) {
      this.selectedGroupId = selected;
    },
    validate: function() {
      let isValid = true;
      let errors = {};

      this.$refs.messageForm.validate(errors);
      if(this.stepNo == 1){
        this.$refs.messageActionForm.validate(errors);
      }

      if(this.stepNo >= 2){
        if(this.spanDay == null){
          errors['span_day_select'] = '日数を入力してください';
        }
        if(this.spanHour == null){
          errors['span_hour_select'] = '時を入力してください';
        }

        if(this.spanMinute == null){
          errors['span_minute_select'] = '分を入力してください';
        }

        if(this.deliverTarget == null){
          errors['deliver_target_select'] = 'アクションを入力してください';
        }
      }

      if(Object.keys(errors).length > 0){
        this.showErrors(errors);
        isValid = false;
      }

      this.isValidated = true;

      return isValid;
    },
    appendForm(params,name,value){
      // null/undefinedの場合のみスキップ、空文字列や0は送信する
      if(value !== null && value !== undefined){
        params.append(name,value);
      }
    },
    appendUtmParameter(url, value) {
      let parameterValue = this.customUtmParameters[value];
      // parameterValueが存在しない、または文字列でない場合は元のURLを返す
      if (!parameterValue || typeof parameterValue !== 'string') {
        return url;
      }
      if (parameterValue.startsWith('?') || parameterValue.startsWith('&')) {
        parameterValue = parameterValue.substring(1);
      }
      url += (url.includes('?') ? '&' : '?') + parameterValue;
      return url;
    },
    saveMessage: function() {
      let sendStartDate = null;
      let sendEndDate = null;
      let regularType = '';

      if(this.stepNo == 1){
        if(this.messageAction.deliverType == 1){
          // 予約
          sendStartDate = moment(this.messageAction.sendStartDate).format('YYYY-MM-DD') + ' ' + this.messageAction.sendStartTime + ':00';
        } else if(this.messageAction.deliverType == 3){
          // 定期
          sendStartDate = moment(this.messageAction.regularStartDate).format('YYYY-MM-DD') + ' 00:00:00';
          sendEndDate = moment(this.messageAction.regularEndDate).format('YYYY-MM-DD') + ' 00:00:00';
          for(let day = 0; day < 7; day++){
            if(this.messageAction.regularType.includes(''+day)){
              regularType += '1';
            } else {
              regularType += '0';
            }
          }
        } else if(this.messageAction.deliverType == 4){
          // 即時
        }
      } else {
        this.messageAction.deliverType = 1; // 予約
        sendStartDate = moment(this.previousStartDate).add(this.spanDay, 'days').format('YYYY-MM-DD ') +
          ('00' + this.spanHour).slice(-2) + ':' + ('00' + this.spanMinute).slice(-2) + ':00'
        this.messageAction.sendStartTime + ':00';
      }

      let clickUrl = this.message.clickUrl;
      if (this.message.customUtmParameter) {
        clickUrl = this.appendUtmParameter(clickUrl, this.message.customUtmParameter);
      }

      //*
      let params = new FormData();
      this.appendForm(params,'message_id',this.messageId);
      // シナリオ配信専用画面からの保存であることをサーバー側 403 ガードに伝えるため scenario_id を送る
      this.appendForm(params,'scenario_id',this.scenario.scenario_id);
      this.appendForm(params,'service_type',2); // TODO ブラウザ以外は？
      this.appendForm(params,'message_name',this.scenario.scenario_name + '[メッセージ' + this.stepNo + ']');
      this.appendForm(params,'message_title',this.message.messageTitle);
      this.appendForm(params,'message_text',this.message.messageText);
      this.appendForm(params,'click_url',clickUrl);
      this.appendForm(params,'image_url',this.message.iconUrl);
      this.appendForm(params,'large_image_url',this.message.largeImageUrl);
      this.appendForm(params,'require_interaction',this.messageAction.requireInteraction);
      if(this.message.hasButtonA){
        let actionButtonUrlA = this.message.actionButtonUrlA;
        if (this.message.customUtmParameterActionA) {
          actionButtonUrlA = this.appendUtmParameter(actionButtonUrlA, this.message.customUtmParameterActionA);
        }
        this.appendForm(params,'action_button_text_a',this.message.actionButtonTextA);
        this.appendForm(params,'action_button_url_a',actionButtonUrlA);
        if(this.message.hasButtonB){
          let actionButtonUrlB = this.message.actionButtonUrlB;
          if (this.message.customUtmParameterActionB) {
            actionButtonUrlB = this.appendUtmParameter(actionButtonUrlB, this.message.customUtmParameterActionB);
          }
          this.appendForm(params,'action_button_text_b',this.message.actionButtonTextB);
          this.appendForm(params,'action_button_url_b',actionButtonUrlB);
        }
      }
      this.appendForm(params,'group_id',this.selectedGroupId);
      //this.appendForm(params,'group_name',this.newGroupName);
      this.appendForm(params,'deliver_type',this.messageAction.deliverType);
      this.appendForm(params,'send_start_date',sendStartDate);
      this.appendForm(params,'send_end_date',sendEndDate);
      this.appendForm(params,'regular_type',regularType);
      this.appendForm(params,'target_start_time',this.messageAction.targetStartTime);
      params.append('ad_flag', this.message.adFlag ? 1 : 0);
      params.append('icon_file',this.message.selectedIconFile);
      params.append('large_image_file',this.message.selectedLargeImageFile);
      params.append('condition_join_type', this.message.conditionJoinType);
      //*/

      axios.post('/api/message/save',params)
        .then(res => {
          if(this.handleResponse(res)){
            this.setCondition(res.data.message_id);
          } else {
            this.isError = true;
            this.errorMessage = (res && res.data && res.data.message)
              ? res.data.message
              : 'メッセージの保存に失敗しました';
          }

          setTimeout(() => {
            this.isLoadingConfirmBtn = false;
            this.isLoadingNextBtn = false;
            this.isLoadingSaveBtn = false;
          }, 300);
        })
        .catch(error => {
          this.handleHttpError(error);
          this.isError = true;
          this.errorMessage = 'メッセージの保存に失敗しました';
          setTimeout(() => {
            this.isLoadingNextBtn = false;
            this.isLoadingSaveBtn = false;
          }, 300);
        });
    },

    setCondition: function(messageId) {
      //*
      let params = new FormData();
      this.appendForm(params,'scenario_id',this.scenario.scenario_id);
      this.appendForm(params,'message_id',messageId);
      this.appendForm(params,'step_no',this.stepNo);
      this.appendForm(params,'deliver_target',this.deliverTarget);
      this.appendForm(params,'condition_ids',this.conditionIds);
      this.appendForm(params,'topic_condition_ids',this.topicConditionIds);
      this.appendForm(params,'condition_join_type', this.message.conditionJoinType);
      //*/

      axios.post('/api/scenario/setmessage',params)
        .then(res => {
          if(this.handleResponse(res)){
            location.href = this.nextUrl;
          } else {
            this.isError = true;
            this.errorMessage = (res && res.data && res.data.message)
              ? res.data.message
              : 'メッセージの保存に失敗しました';
          }

          setTimeout(() => {
            this.isLoadingConfirmBtn = false;
            this.isLoadingNextBtn = false;
            this.isLoadingSaveBtn = false;
          }, 300);
        })
        .catch(error => {
          this.handleHttpError(error);
          this.isError = true;
          this.errorMessage = 'メッセージの保存に失敗しました';
          setTimeout(() => {
            this.isLoadingNextBtn = false;
            this.isLoadingSaveBtn = false;
          }, 300);
        });

    },

    // -----------------------------------------------------------------------------------------------------
    // エミット系メソッド一覧: 子孫のUI操作にフックエミットコールされるか、引き渡した関数オブジェクトからコールされるメソッド
    // -----------------------------------------------------------------------------------------------------
    // クリック: エラーモーダルを閉じる処理
    onCloseErrorModal: function() {
      this.isError = false
      this.errorMessage = ''
    },
    onDeliverTargetSelect: function(selected){
      this.deliverTarget = selected;
    },
    onSpanDaySelect: function(selected){
      this.spanDay = selected;
    },
    onSpanHourSelect: function(selected){
      this.spanHour = selected;
    },
    onSpanMinuteSelect: function(selected){
      this.spanMinute = selected;
    },
    // 画像最適化処理の開始
    onStartOptimize: function() {
      this.isLoadingOptimizeImage = true;
    },
    // 画像最適化処理の完了
    onEndOptimize: function() {
      this.isLoadingOptimizeImage = false;
    },
  }
}
</script>
